package info.rezident.app.core

import kotlinx.browser.window

object LocalStorage {

    const val KEY_QUIZ_USER_ANSWERS = "quiz_user_answers"
    const val KEY_CELEBRATED_QUIZ_IDS = "celebrated_quiz_ids"

    fun save(key: String, value: String) {
        window.localStorage.setItem(key, value)
    }

    fun get(key: String): String? {
        return window.localStorage.getItem(key)
    }

    fun remove(key: String) {
        window.localStorage.removeItem(key)
    }

    fun clear() {
        window.localStorage.clear()
    }
}